import { Entry } from '../Entry'

export function Entry20220427() {
  return (
    <Entry title="27/04/2022 - v3.0.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12504/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
